import React, { useState } from "react";
import "../DoctorData/DoctorData.css";
import Avatar from "../../assets/avatar.png";
import { Link } from "react-router-dom";
import { useNavigate } from 'react-router-dom';
import { ToggleButton, ToggleButtonGroup } from "react-bootstrap";


const doctors = [
  {
    doctorFullName: "Dr. Aisha Khan",
    hospitalName: "MetroCare Clinic",
    specialty: "dermatology",
    onlineConsultation: true,
    contactPhone: "9876543210",
    profilePictureUrl: Avatar,
    shortBio: "Skin specialist with a focus on cosmetic treatments",
    yearsOfExperience: 8
  },
  {
    doctorFullName: "Dr. Rajiv Mehta",
    hospitalName: "Apollo Hospital",
    specialty: "neurology",
    onlineConsultation: false,
    contactPhone: "9123456780",
    profilePictureUrl: Avatar,
    shortBio: "Expert in neurodegenerative disorders and stroke care",
    yearsOfExperience: 12
  },
  {
    doctorFullName: "Dr. Emily Chen",
    hospitalName: "Green Valley Medical Center",
    specialty: "pediatrics",
    onlineConsultation: true,
    contactPhone: "9988776655",
    profilePictureUrl: Avatar,
    shortBio: "Child health specialist with a gentle approach",
    yearsOfExperience: 6
  },
  {
    doctorFullName: "Dr. Omar Farouk",
    hospitalName: "Sunrise Hospital",
    specialty: "orthopedics",
    onlineConsultation: false,
    contactPhone: "9090909090",
    profilePictureUrl: Avatar,
    shortBio: "Joint replacement and sports injury expert",
    yearsOfExperience: 15
  },
  {
    doctorFullName: "Dr. Priya Nair",
    hospitalName: "CareWell Hospital",
    specialty: "gynecology",
    onlineConsultation: true,
    contactPhone: "8888888888",
    profilePictureUrl: Avatar,
    shortBio: "Women's health advocate and fertility specialist",
    yearsOfExperience: 10
  },
  {
    doctorFullName: "Dr. Daniel Lee",
    hospitalName: "City General Hospital",
    specialty: "cardiology",
    onlineConsultation: true,
    contactPhone: "1234567890",
    profilePictureUrl: Avatar,
    shortBio: "Heart specialist with 10+ years of experience",
    yearsOfExperience: 11
  },
  {
    doctorFullName: "Dr. Kavita Joshi",
    hospitalName: "Lotus Medical Center",
    specialty: "psychiatry",
    onlineConsultation: true,
    contactPhone: "7777777777",
    profilePictureUrl: Avatar,
    shortBio: "Mental health expert with a holistic approach",
    yearsOfExperience: 9
  },
  {
    doctorFullName: "Dr. Michael Brown",
    hospitalName: "Unity Health",
    specialty: "urology",
    onlineConsultation: false,
    contactPhone: "6666666666",
    profilePictureUrl: Avatar,
    shortBio: "Specialist in urinary tract and male reproductive health",
    yearsOfExperience: 13
  },
  {
    doctorFullName: "Dr. Fatima Siddiqui",
    hospitalName: "Harmony Hospital",
    specialty: "endocrinology",
    onlineConsultation: true,
    contactPhone: "5555555555",
    profilePictureUrl: Avatar,
    shortBio: "Diabetes and hormone disorder specialist",
    yearsOfExperience: 7
  },
  {
    doctorFullName: "Dr. Arjun Patel",
    hospitalName: "Global Health Institute",
    specialty: "oncology",
    onlineConsultation: false,
    contactPhone: "4444444444",
    profilePictureUrl: Avatar,
    shortBio: "Cancer care expert with a research background",
    yearsOfExperience: 14
  },
  {
    doctorFullName: "Dr. Sofia Martinez",
    hospitalName: "Wellness First Clinic",
    specialty: "nutrition",
    onlineConsultation: true,
    contactPhone: "3333333333",
    profilePictureUrl: Avatar,
    shortBio: "Diet and lifestyle coach for chronic conditions",
    yearsOfExperience: 5
  },
  {
    doctorFullName: "Dr. Harsh Vardhan",
    hospitalName: "PrimeCare Hospital",
    specialty: "pulmonology",
    onlineConsultation: true,
    contactPhone: "2222222222",
    profilePictureUrl: Avatar,
    shortBio: "Lung and respiratory care specialist",
    yearsOfExperience: 10
  },
  {
    doctorFullName: "Dr. Grace Kim",
    hospitalName: "Tranquil Minds Center",
    specialty: "psychology",
    onlineConsultation: true,
    contactPhone: "1111111111",
    profilePictureUrl: Avatar,
    shortBio: "Cognitive behavioral therapist and trauma specialist",
    yearsOfExperience: 6
  },
  {
    doctorFullName: "Dr. Anil Sharma",
    hospitalName: "Heritage Hospital",
    specialty: "gastroenterology",
    onlineConsultation: false,
    contactPhone: "1010101010",
    profilePictureUrl: Avatar,
    shortBio: "Digestive system expert with 20+ years of experience",
    yearsOfExperience: 20
  },
  {
    doctorFullName: "Dr. Linda Park",
    hospitalName: "Hope Medical Center",
    specialty: "rheumatology",
    onlineConsultation: true,
    contactPhone: "2020202020",
    profilePictureUrl: Avatar,
    shortBio: "Arthritis and autoimmune disease specialist",
    yearsOfExperience: 12
  },
  {
    doctorFullName: "Dr. Naveen Gupta",
    hospitalName: "Silverline Hospital",
    specialty: "nephrology",
    onlineConsultation: false,
    contactPhone: "3030303030",
    profilePictureUrl: Avatar,
    shortBio: "Kidney care and dialysis expert",
    yearsOfExperience: 16
  },
  {
    doctorFullName: "Dr. Chloe Nguyen",
    hospitalName: "BrightCare Clinic",
    specialty: "family medicine",
    onlineConsultation: true,
    contactPhone: "4040404040",
    profilePictureUrl: Avatar,
    shortBio: "General practitioner for all age groups",
    yearsOfExperience: 7
  },
  {
    doctorFullName: "Dr. Rakesh Bansal",
    hospitalName: "LifeSpring Hospital",
    specialty: "hematology",
    onlineConsultation: false,
    contactPhone: "5050505050",
    profilePictureUrl: Avatar,
    shortBio: "Blood disorder and cancer specialist",
    yearsOfExperience: 18
  },
  {
    doctorFullName: "Dr. Julia Roberts",
    hospitalName: "CarePoint Medical",
    specialty: "geriatrics",
    onlineConsultation: true,
    contactPhone: "6060606060",
    profilePictureUrl: Avatar,
    shortBio: "Elderly care and chronic condition management",
    yearsOfExperience: 9
  },
  {
    doctorFullName: "Dr. Manish Verma",
    hospitalName: "Zenith Hospital",
    specialty: "radiology",
    onlineConsultation: false,
    contactPhone: "7070707070",
    profilePictureUrl: Avatar,
    shortBio: "Imaging and diagnostic expert",
    yearsOfExperience: 11
  },
  {
    doctorFullName: "Dr. Sara Ali",
    hospitalName: "NovaCare Clinic",
    specialty: "pathology",
    onlineConsultation: true,
    contactPhone: "8080808080",
    profilePictureUrl: Avatar,
    shortBio: "Lab diagnostics and biopsy specialist",
    yearsOfExperience: 8
  },
  {
    doctorFullName: "Dr. Vikram Desai",
    hospitalName: "Pulse Hospital",
    specialty: "anesthesiology",
    onlineConsultation: false,
    contactPhone: "9090909091",
    profilePictureUrl: Avatar,
    shortBio: "Pain management and surgical anesthesia expert",
    yearsOfExperience: 13
  },
  {
    doctorFullName: "Dr. Tanya Roy",
    hospitalName: "HealWell Center",
    specialty: "ophthalmology",
    onlineConsultation: true,
    contactPhone: "9191919191",
    profilePictureUrl: Avatar,
    shortBio: "Eye care and vision correction specialist",
    yearsOfExperience: 10
  }
];

const PharmacyData = ({activePage = "Pharmacy"}) => {
    const navigate = useNavigate();
  const [page, setPage] = useState(1);
  const [tabActive, setTabActive] = useState(activePage);
  const itemsPerPage = 10;
  const totalPages = Math.ceil(doctors.length / itemsPerPage);

  const paginatedDoctors = doctors.slice(
    (page - 1) * itemsPerPage,
    page * itemsPerPage
  );

  const handleToggleChange = (val) =>{
      val === "Yes" ? navigate("/doctor-data") : navigate("/pharmacy-data");
      setTabActive(val)
  }

  return (
    <div className="apt-main-content" style={{ minHeight: "100vh" }}>
    <div className="innerWrapper">
        <div className="d-flex justify-content-between align-items-center mb-4">
          <div className="dataPageToggle">
            <ToggleButtonGroup
              type="radio"
              name="tableData"
              value={tabActive}
              onChange={(val) => handleToggleChange(val)}
            >
              <ToggleButton
                id="doctor"
                value="Yes"
                variant={
                  tabActive === "Doctors" ? "primary" : "outline-primary"
                }
                style={{ minWidth: 80 }}
              >
                Doctors
              </ToggleButton>
              <ToggleButton
                id="pharmacy"
                value="No"
                variant={tabActive === "Pharmacy" ? "primary" : "outline-primary"}
                style={{ minWidth: 80 }}
              >
                Pharmacy
              </ToggleButton>
            </ToggleButtonGroup>
          </div>

          <div className="d-flex align-items-center gap-2">
            <Link to="/doctor-form">
              <button className="nav-btnn btn">+ Add New Doctor</button>
            </Link>
            <Link to="/pharmcy-form">
              <button className="nav-btnn btn">+ Add New Pharmacy</button>
            </Link>
          </div>
        </div>
      <div className="apt-appointments-section">
        <div className="apt-section-header">
        </div>
        <div className="apt-appointments-table">
          <table>
            <thead>
              <tr>
                <th>#</th>
                <th>Name</th>
                <th>Hospital</th>
                <th>Location</th>
                <th>Consultation</th>
                <th>Contact</th>
                <th>Bio</th>
                <th>Experience</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {paginatedDoctors.map((doc, idx) => (
                <tr key={idx}>
                  <td>{(page - 1) * itemsPerPage + idx + 1}</td>
                  <td>
                    <div className="apt-patient-info">
                      <img
                        src={doc.profilePictureUrl}
Avatar
                        height={32}
                        style={{ objectFit: "cover" }}
                      />
                      <span>{doc.doctorFullName}</span>
                    </div>
                  </td>
                  <td>{doc.hospitalName}</td>
                  <td>
                    <span className="apt-appointment-type onsite">
                      {doc.specialty.charAt(0).toUpperCase() + doc.specialty.slice(1)}
                    </span>
                  </td>
                  <td>
                    <span
                      className={
                        "apt-appointment-type " +
                        (doc.onlineConsultation ? "online" : "onsite")
                      }
                    >
                      {doc.onlineConsultation ? "Online" : "On-Site"}
                    </span>
                  </td>
                  <td>{doc.contactPhone}</td>
                  <td style={{ maxWidth: 180 }}>{doc.shortBio}</td>
                  <td>
                    <span className="apt-appointment-type onsite">
                      {doc.yearsOfExperience} yrs
                    </span>
                  </td>
                  <td>
                    <div className="apt-action-buttons">
                      {/* {doc.onlineConsultation && (
                        <button className="apt-join-btn">Join Now</button>
                      )} */}
                      <button className="apt-view-btn">View</button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
        {/* Pagination */}
        <div className="apt-pagination">
          <span className="apt-pagination-info">
            Showing {(page - 1) * itemsPerPage + 1}-
            {Math.min(page * itemsPerPage, doctors.length)} of {doctors.length}
          </span>
          <div className="apt-pagination-controls">
            <button
              className="apt-pagination-btn"
              onClick={() => setPage(page - 1)}
              disabled={page === 1}
            >
              &lt; Previous
            </button>
            <div className="apt-page-numbers">
              {[...Array(totalPages)].map((_, idx) => (
                <button
                  key={idx + 1}
                  className={`apt-page-btn${page === idx + 1 ? " active" : ""}`}
                  onClick={() => setPage(idx + 1)}
                >
                  {idx + 1}
                </button>
              ))}
            </div>
            <button
              className="apt-pagination-btn apt-next-btn"
              onClick={() => setPage(page + 1)}
              disabled={page === totalPages}
            >
              Next &gt;
            </button>
          </div>
        </div>
      </div>
      </div>
    </div>
  );
};

export default PharmacyData;